/** Sticky nav expand-compact CTA default width (see `_button.scss`). */
export const NAV_EXPAND_COMPACT_CTA_WIDTH_REM = 10;

/** Icon column + outer padding (rem) for expand-compact nav CTAs. */
const NAV_EXPAND_COMPACT_LEADING_REM = 2.5625;

/** Trailing padding inside the label rail (rem). */
const NAV_EXPAND_COMPACT_TRAILING_REM = 0.75;

/**
 * Approximate rem per character at nav CTA label size (0.875rem, Satoshi 500).
 * Reserve space for wider accented and mixed-case localized labels.
 */
const NAV_EXPAND_COMPACT_CHAR_REM = 0.43;

/** Labels longer than this get extra width per character (hyphens, mixed case). */
const NAV_EXPAND_COMPACT_LONG_LABEL_THRESHOLD = 20;

/**
 * Extra rem per character beyond {@link NAV_EXPAND_COMPACT_LONG_LABEL_THRESHOLD}.
 * Mixed case and uppercase (e.g. "SEO") need more than {@link NAV_EXPAND_COMPACT_CHAR_REM}.
 */
const NAV_EXPAND_COMPACT_LONG_LABEL_CHAR_REM = 1;

/**
 * Width for the sticky nav primary CTA from label length (no DOM measurement).
 * Wider labels (e.g. SEO book-call copy) grow the button and pill gap together.
 */
export function navExpandCompactCtaWidthRem(label: string): number {
  const chars = [...label].length;
  const longLabelExtraRem =
    chars > NAV_EXPAND_COMPACT_LONG_LABEL_THRESHOLD
      ? (chars - NAV_EXPAND_COMPACT_LONG_LABEL_THRESHOLD) *
        NAV_EXPAND_COMPACT_LONG_LABEL_CHAR_REM
      : 0;
  const computed =
    NAV_EXPAND_COMPACT_LEADING_REM +
    chars * NAV_EXPAND_COMPACT_CHAR_REM +
    NAV_EXPAND_COMPACT_TRAILING_REM +
    longLabelExtraRem;

  const widthRem = Math.max(NAV_EXPAND_COMPACT_CTA_WIDTH_REM, computed);
  return Math.ceil(widthRem * 4) / 4;
}

export function navExpandCompactCtaWidthCssVar(label: string): string {
  return `${navExpandCompactCtaWidthRem(label)}rem`;
}
